import { useEffect, useState } from 'react';
import { masterclassApi, errorMessage } from '../masterclasses/api';

// Use the same server taxonomy as the student menu, never a second hard-coded list.
export const useFusionTaxonomy = () => {
  const [modules, setModules] = useState([]), [loading, setLoading] = useState(true);
  const [error, setError] = useState(''), [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController(); setLoading(true); setError('');
    masterclassApi.get('/interactive-lessons/navigation', { signal: controller.signal })
      .then(({ data }) => { if (!controller.signal.aborted) setModules(data.modules); })
      .catch(err => { if (!controller.signal.aborted) setError(errorMessage(err)); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [attempt]);
  const childrenFor = module => (modules.find(item => item.name === module)?.submodules || []).map(item => item.name).filter(name => name !== 'General');
  return { modules, childrenFor, loading, error, retry: () => setAttempt(value => value + 1) };
};